module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-6-549a657a5bb59e721f9ea17ebc6c67ce.jpg";